

























































































































































































































































































import IGood from '@/store/models/IGood';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IOutbound from '@/store/models/IOutbound';
import moment from 'moment';
import IStock from '@/store/models/IStock';
import OutboundDetailCustomerStockSelector from '@/components/selectors/Outbounds/OutboundDetailCustomerStockSelector.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import IListPalletType from '@/store/models/IListPalletType';

@Component({
    components: {
        OutboundDetailCustomerStockSelector,
        Snackbar
    }
})
export default class OutboundDetailSelector extends Vue {
    languageText: string = "";
    menu2: boolean = false;
    searchOutboundDetail: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    selectedFormatToPrint: string = "excel";
    headers: any = [
        { text: 'Good', align: 'start', value: 'goodName' },
        { text: 'Good Code', value: 'goodCode' },
        { text: 'Inb. Code', value: 'codeInbound' },
        { text: 'Inb. Code Destination', value: 'codeDestination' },
        { text: 'Total pallets', value: 'totalPallets' },
        { text: 'Pallet type', value: 'palletName' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Weight per pallet (Kg)', value: 'weight' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Cases loss', value: 'casesLoss' },
        { text: 'In delivery note', value: 'inDeliveryNote' },
        { text: 'Best before date', value: 'bestBeforeDateSort' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Language', value: 'language' },
        { text: 'Douana document', value: 'documentation' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IOutboundDetail = {
        id: "",
        idOutbound: "",
        idInbound: "",
        idWarehouse: "",
        codeInbound: "",
        codeDestination: "",
        idGood: "",
        goodName: "",
        totalPallets: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        idInboundDeliveryNoteDetail: "",
        inDeliveryNote: 0,
        warehouseName: "",
        language: "",
        documentation: false,
        availableCasesFinal: 0,
        casesLoss: 0,
        weight: 0,
        liters: 0,
        totalValue: 0,
        idPalletCustomer: "",
        idListPallet: "",
        palletName: "",
        goodCode: ""
    }
    defaultItem : IOutboundDetail = {
        id: "",
        idOutbound: "",
        idWarehouse: "",
        idInbound: "",
        codeInbound: "",
        codeDestination: "",
        idGood: "",
        goodName: "",
        totalPallets: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: new Date(),
        idInboundDeliveryNoteDetail: "",
        inDeliveryNote: 0,
        warehouseName: "",
        language: "",
        documentation: false,
        availableCasesFinal: 0,
        casesLoss: 0,
        weight: 0,
        liters: 0,
        totalValue: 0,
        idPalletCustomer: "",
        idListPallet: "",
        palletName: "",
        goodCode: ""
    }

    @Prop({ type: Array, required: true })
    OutboundDetailList !: IOutboundDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop({ type: Array, required: true })
    StockListCustomer !: IStock[];
    @Prop({ type: Array, required: true })
    StockListCustomerPalletsAmount !: IStock[];
    @Prop()
    SelectedOutbound !: IOutbound;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedOutbounds !: boolean;
    @Prop({ type: Boolean, default: false })
    ScannerActive !: boolean;
    @Prop({ type: Boolean, default: false })
    OutboundImportXml !: boolean;
    @Prop({ type: Array, required: true })
    PalletTypesList!: IListPalletType[];
    @Prop()
    value !: IOutboundDetail | null;
    
    selectedOutboundDetail : IOutboundDetail[] = [];
    selectedGoodName : string = "";
    bestBeforeDate: string = new Date().toISOString().substr(0, 10);
    selectedGood = {} as IGood;
    selectedCustomerStockDetail : IOutboundDetail[] = [];
    xmlDialog: boolean = false;
    xmlRows: any[] = [];
    xmlHeaders: any[] = [
        { text: 'Bestellnummer (Good Code)', value: 'bestellnummer' },
        { text: 'Menge', value: 'menge' },
        { text: 'Pallets needed', value: 'palletsNeeded' },
        { text: 'Matched Good', value: 'matched' },
        { text: 'Selected pallets', value: 'selectedPallets' },
        { text: 'Notes', value: 'note' }
    ];
    xmlErrors: string[] = [];
    xmlWarnings: string[] = [];
    xmlGeneratedOutboundDetails: IOutboundDetail[] = [];
    xmlSelectedFile: File | null = null;

    async mounted() {
        await this.SetLanguageText();
        
        // 👉 Si el escáner está activo, cambiar cabecera de Language → Merken nummer
        if (this.ScannerActive) {
            const idx = this.headers.findIndex((h: { text: string; value: string }) => h.value === 'language');
            if (idx !== -1) {
                this.headers[idx].text = 'Merken nummer';
                this.headers[idx].value = 'idPalletCustomer';
            }
        }
    }

    @Watch('languageText')
    onLanguageTextChanged(newValue: string) {
        this.headers = this.headers.map((header: any) => {
            if (header.value === 'language') {
                return {
                    text: newValue,
                    align: header.align,
                    value: header.value
                };
            }
            return header;
        });
    }

    async SetLanguageText() {
        if (this.languageText === "") {
            let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
            let settingsCompany = SettingsCompany.Settings.InboundDetailLanguageText;
            let settingsCompanyApi = new SettingsCompanyApi("Outbounds");
            let setting : ISettingsCompany[] = await settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingsCompany);
            if (setting.length === 0) {
                this.languageText = "Language";
            } else {
                this.languageText = setting[0].value;
            }
        }
    }
    get TotalWeight() {
        const totalWeight = this.OutboundDetailList.reduce((sum, item) => {
            const pallets: any = Number(item.totalPallets) || 1;
            const weightPerPallet = Number(item.weight) || 0;
            return sum + pallets * weightPerPallet;
        }, 0);

        return totalWeight.toFixed(2); // muestra 2 decimales
    }

    GetValueDocumentation(documentationNeeded : boolean) {
        if (documentationNeeded !== null && documentationNeeded !== undefined) {
            if (documentationNeeded.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }

        return 'No';
    }

    GetTotalGoods(item: IOutboundDetail) {
        return item.totalCases * item.goodsPerCase;
    }

    HasRightModifyCompletedOutbounds() {
        if (!this.Permissions[0].isWritable || (this.SelectedOutbound.statusName === 'Completed' && !this.CanModifyCompletedOutbounds)) return false;
        return true;
    }

    get TotalCases() {
        return this.OutboundDetailList.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
    }

    get TotalGoods() {
        return this.OutboundDetailList.reduce((sum, current) => Number(sum) + Number(current.totalGoods), 0);
    }

    get TotalPallets() {
        return this.OutboundDetailList
        .filter(item => {
            const palletType = this.PalletTypesList.find(p => p.id === item.idListPallet);

            if (palletType) {
                return palletType.notBillable !== true;
            }

            const palletName = (item.palletName || "").toLowerCase();
            return palletName !== "colli" && palletName !== "case";
        })
        .reduce((sum, current) => sum + Number(current.totalPallets || 0), 0);
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Outbound Detail' : 'Edit Outbound Detail'; }

    get outboundItemsWithSortKeys() {
        return (this.OutboundDetailList || []).map((i: IOutboundDetail) =>
            Object.assign({}, i, {
                bestBeforeDateSort: this.toIsoDate(i.bestBeforeDate)
            })
        );
    }

    toIsoDate(v: any): string {
        if (!v) return '';

        // si ya viene como Date
        if (v instanceof Date) {
            return moment(v).format('YYYY-MM-DD');
        }

        // si viene como string parseable
        const m = moment(v, [moment.ISO_8601, 'DD-MM-YYYY', 'DD/MM/YYYY'], true);
        if (m.isValid()) return m.format('YYYY-MM-DD');

        // fallback: intentar new Date
        const d = new Date(v);
        if (!isNaN(d.getTime())) return moment(d).format('YYYY-MM-DD');

        return '';
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    @Watch('value')
    updateSelection(newValue : IOutboundDetail | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedOutboundDetail = [];
        } else {
            this.selectedOutboundDetail = [newValue];
        }
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.SelectedOutbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }

        return false;
    }

    getColor(item : IOutboundDetail) : string {
        if (item.inDeliveryNote === null) {
            item.inDeliveryNote = 0;
            return 'orange';
        } else if (item.inDeliveryNote < item.totalCases) return 'orange';
        else if (item.inDeliveryNote === item.totalCases) return 'green';
        item.inDeliveryNote = 0;
        return 'orange';
    }

    saveOutboundDetail () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.selectedCustomerStockDetail.length === 0) {
                this.showMessageWarning('Please select a delivery notes detail to save');
            } else {
                this.selectedCustomerStockDetail.forEach(e => { e.totalCases = e.availableCasesFinal; });
                this.$emit('saveOutboundDetail', this.selectedCustomerStockDetail);
                this.close();
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    getStockPalletsAmount(item: IOutboundDetail) {
        this.$emit('getStockPalletsAmount', item);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    deleteOutboundDetail(outboundDetail: IOutboundDetail) {
        this.$emit('deleteOutboundDetail', outboundDetail);
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    select(item: IOutboundDetail): void {
        this.selectedOutboundDetail = [item];
        this.$emit('input', item);
    }

    getCustomerStockItems() {
        this.selectedCustomerStockDetail = [];
        this.$emit('getCustomerStock');
    }

    printOutboundDetails() {
        this.$emit('printOutboundDetail', this.selectedFormatToPrint);
    }
    openXmlImportDialog() {
        this.getCustomerStockItems();

        this.xmlSelectedFile = null;
        this.xmlErrors = [];
        this.xmlWarnings = [];
        this.xmlRows = [];
        this.xmlGeneratedOutboundDetails = [];
        this.xmlDialog = true;
    }

    closeXmlDialog() {
        this.xmlDialog = false;

        this.xmlSelectedFile = null;
        this.xmlErrors = [];
        this.xmlWarnings = [];
        this.xmlRows = [];
        this.xmlGeneratedOutboundDetails = [];
    }

    get canSaveXmlImport(): boolean {
        return this.xmlGeneratedOutboundDetails.length > 0 && this.xmlErrors.length === 0;
    }

    onXmlFileSelected(file: any) {
        this.xmlErrors = [];
        this.xmlWarnings = [];
        this.xmlRows = [];
        this.xmlGeneratedOutboundDetails = [];

        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            try {
                const text = String(reader.result || "");
                this.parseAndPrepareXml(text);
            } catch (err) {
                this.xmlErrors.push("Error reading XML file: " + err);
            }
        };
        reader.onerror = () => {
            this.xmlErrors.push("Error reading XML file.");
        };

        reader.readAsText(file);
    }

    parseAndPrepareXml(xmlText: string) {
    // 1) limpiar basura tipo "This XML file does not appear..." si viene pegado
        const start = xmlText.indexOf("<");
        if (start > 0) {
            xmlText = xmlText.substring(start);
        }

        // 2) sanar XML inválido (ampersands sin escapar)
        xmlText = this.sanitizeXml(xmlText);

        // 3) parsear
        const parser = new DOMParser();
        const doc = parser.parseFromString(xmlText, "application/xml");

        const parseError = doc.getElementsByTagName("parsererror");
        if (parseError && parseError.length > 0) {
            this.xmlErrors.push("Invalid XML format. Please verify the XML file.");
            return;
        }

        // 4) extraer Produkts
        const produktNodes = doc.getElementsByTagName("Produkt");
        if (!produktNodes || produktNodes.length === 0) {
            this.xmlErrors.push("No <Produkt> nodes found in XML.");
            return;
        }

        // 5) construir filas desde XML
        const rows: any[] = [];
        for (let i = 0; i < produktNodes.length; i++) {
            const p = produktNodes[i];

            const bestellnummer = this.getNodeText(p, "Bestellnummer");
            const mengeRaw = this.getNodeText(p, "Menge");

            const menge = this.parseNumber(mengeRaw);
            if (!bestellnummer) {
                rows.push({
                    bestellnummer: "",
                    menge: mengeRaw,
                    palletsNeeded: 0,
                    matched: false,
                    selectedPallets: 0,
                    note: "Missing Bestellnummer"
                });
                continue;
            }

            if (menge <= 0) {
                rows.push({
                    bestellnummer: bestellnummer,
                    menge: mengeRaw,
                    palletsNeeded: 0,
                    matched: false,
                    selectedPallets: 0,
                    note: "Invalid Menge"
                });
                continue;
            }

            const palletsNeeded = Math.ceil(menge / 950);

            rows.push({
                bestellnummer: bestellnummer,
                menge: menge,
                palletsNeeded: palletsNeeded,
                matched: false,
                selectedPallets: 0,
                note: ""
            });
        }

        // 6) cruzar con GoodList + StockListCustomer y seleccionar pallets (FIFO BBD)
        this.buildSelectionFromXmlRows(rows);
    }

    buildSelectionFromXmlRows(rows: any[]) {
        const generated: IOutboundDetail[] = [];

        // normaliza stock (puede venir vacío si aún no ha cargado)
        const stockList: any[] = Array.isArray(this.StockListCustomer) ? (this.StockListCustomer as any[]) : [];

        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            const code = String(r.bestellnummer || "").trim();

            // match good por code
            const good = this.GoodList.find(g => String((g as any).code || "").trim() === code);
            if (!good) {
                r.matched = false;
                r.note = `Good not found by code ${code}`;
                continue;
            }

            r.matched = true;

            // filtrar stock del producto
            // intentamos por goodCode en stock o por idGood
            const candidates = stockList
            .filter(s =>
                String((s as any).goodCode || "").trim() === code ||
                String((s as any).idGood || "").trim() === String((good as any).id || "").trim()
            )
            .slice();

            // obtener nombre del good (si existe)
            const goodName = good && ((good as any).name || "");

            // si no hay stock para ese producto
            if (candidates.length === 0) {
                r.selectedPallets = 0;
                r.note = `No stock found for ${code}${goodName ? ' (' + goodName + ')' : ''}`;
                continue;
            }

            // ordenar por bestBeforeDate ASC (más antiguo primero)
            candidates.sort((a, b) => {
                const da = this.safeDate(a.bestBeforeDate);
                const db = this.safeDate(b.bestBeforeDate);
                return da.getTime() - db.getTime();
            });

            const need = Number(r.palletsNeeded) || 0;
            const take = candidates.slice(0, need);

            r.selectedPallets = take.length;

            if (take.length < need) {
                const msg = `Not enough pallets for Good ${code}${goodName ? ' (' + goodName + ')' : ''}. Needed ${need}, found ${take.length}`;
                r.note = msg;
                this.xmlWarnings.push(msg);
            }

            // generar outboundDetails (1 por pallet)
            for (let k = 0; k < take.length; k++) {
                const s: any = take[k];

                const od: IOutboundDetail = Object.assign({}, this.defaultItem);

                // cosas “mínimas” para que el backend lo acepte suelen venir desde stock selector
                od.idOutbound = (this.SelectedOutbound && (this.SelectedOutbound as any).id) ? (this.SelectedOutbound as any).id : "";
                od.idInbound = String(s.idInbound || s.idInboundDetail || s.idInboundDeliveryNote || "");
                od.codeInbound = String(s.codeInbound || "");
                od.codeDestination = String(s.codeDestination || "");

                od.idGood = String((good as any).id || s.idGood || "");
                od.goodName = String(s.goodName || (good as any).name || "");
                od.goodCode = String(s.goodCode || code);

                od.idWarehouse = String(s.idWarehouse || "");
                od.warehouseName = String(s.warehouseName || "");

                od.idListPallet = String(s.idListPallet || "");
                od.palletName = String(s.palletName || "");

                od.bestBeforeDate = s.bestBeforeDate ? new Date(s.bestBeforeDate) : new Date();
                od.language = String(s.language || "");
                od.documentation = Boolean(s.documentation || false);

                od.weight = Number(s.weight || 0);
                od.goodsPerCase = Number(s.goodsPerCase || (good as any).amountPerBox || 0);

                // ✅ Bigbags: 1 pallet = 1 case (por tu lógica de inbound, aquí aplicamos lo mismo)
                od.totalPallets = 1;
                od.availableCasesFinal = 1; // esto se convierte a totalCases al guardar
                od.totalCases = 1;
                od.totalGoods = od.totalCases * od.goodsPerCase;

                od.casesLoss = Number(s.casesLoss || 0);
                od.inDeliveryNote = 0;

                // IMPORTANT: si el backend necesita idInboundDeliveryNoteDetail, lo copiamos si existe:
                od.idInboundDeliveryNoteDetail = String(s.idInboundDeliveryNoteDetail || s.idStock || "");

                generated.push(od);
            }
        }

        this.xmlRows = rows;
        this.xmlGeneratedOutboundDetails = generated;

        if (generated.length === 0 && this.xmlErrors.length === 0) {
            this.xmlWarnings.push("No outbound details generated. Check matches and stock availability.");
        }
    }

    saveXmlImport() {
        if (!this.canSaveXmlImport) {
            this.showMessageWarning("Nothing to save. Please upload a valid XML and ensure stock is available.");
            return;
        }

        // Reutilizamos la misma lógica que el botón Save del dialogo normal:
        // ahí hacéis: totalCases = availableCasesFinal
        const detailsToSave: IOutboundDetail[] = this.xmlGeneratedOutboundDetails.map(d => {
            const copy: any = Object.assign({}, d);
            copy.totalCases = copy.availableCasesFinal;
            return copy as IOutboundDetail;
        });

        this.$emit("saveOutboundDetail", detailsToSave);
        this.closeXmlDialog();
    }

    /** Helpers */

    sanitizeXml(xmlText: string): string {
    // reemplaza & que NO sean entidades válidas
        return xmlText.replace(/&(?!amp;|lt;|gt;|apos;|quot;|#\d+;|#x[0-9A-Fa-f]+;)/g, "&amp;");
    }

    getNodeText(parent: Element, tagName: string): string {
        const nodes = parent.getElementsByTagName(tagName);
        if (!nodes || nodes.length === 0) return "";
        const n = nodes[0];
        if (!n || !n.textContent) return "";
        return String(n.textContent).trim();
    }

    parseNumber(v: any): number {
        if (v === null || v === undefined) return 0;
        const s = String(v).trim().replace(",", ".");
        const n = Number(s);
        if (isNaN(n)) return 0;
        return n;
    }

    safeDate(v: any): Date {
        if (!v) return new Date(8640000000000000); // muy futuro
        const d = new Date(v);
        if (isNaN(d.getTime())) return new Date(8640000000000000);
        return d;
    }
}
